import {  createHashHistory } from "history";
// export default createBrowserHistory();
export default createHashHistory();
